// extracted by mini-css-extract-plugin
module.exports = {"container":"RatingIconLabel_container__2jIaU","icon":"RatingIconLabel_icon__o9vpd","label":"RatingIconLabel_label__336f1"};